import IconSocialNetworks from "./icon-social-networks";

export default IconSocialNetworks;